export const SET_CATEGORIES = 'SET_CATEGORIES';
export const SET_CATEGORIES_ACHAT = 'SET_CATEGORIES_ACHAT';
export const SET_SUPPORT_COMMERCIAUX = 'SET_SUPPORT_COMMERCIAUX';
export const RESET_STATE = 'RESET_STATE';
